import * as React from "react";
import {cs} from "@Common/react/chain-services";

import {consumeContext} from "@Common/react/context";
import "./postal-protect-ad.scss";

const postalProtectURL = "https://www.xpressdocs.com/s/postal-protect/"
const subscriptionURL  = "/manage-subscriptions"

export const PostalProtectAd = () => cs(
    consumeContext("session"),
    consumeContext("routerHistory"),
    ({session, routerHistory}) => (<>
        <div className="postal-protect postal-protect-pp37">
            <div className="background">
                <img alt="XD+" className="xd" src={require("../common/xd-logo.svg")}/>
            </div>
            {["Premium", "Loyalty"].includes(session.data.agent?.subscriptions?.[0]?.planType) ? (<>
                <div className="postal-protect-text">
                    Hey XD+ {session.data.agent.subscriptions[0].planType} subscriber,<br/>
                    enjoy an exclusive 50% off<br/>
                    {PostalProtectLink()}
                </div>
                <div className="logo">
                    <img alt="XD+" className="xd-plus-image" src={require("../common/xd-plus-logo.png")}/>
                </div>
            </>) : (<>
                <div className="postal-protect-text">
                    You could be saving 50% on<br/>
                    {PostalProtectLink()} with an<br/>
                    XD+ subscription!
                    <br/>
                    {SubscribeLink(routerHistory)}
                </div>
                <div className="logo">
                    <img className="xd-plus-image" src={require("../common/xd-plus-logo.png")} alt="XD+ Logo"/>
                </div>
            </>)}
        </div>
    </>)
)

const PostalProtectLink = () => (
    <a className="postal-protect-link"
        href={postalProtectURL}
        target="_blank"
    >Postal Protect!</a>
)

const SubscribeLink = (routerHistory) => (
    <button className="subscribe"
        onClick={() => routerHistory.push(subscriptionURL)}
        xd-qa-type="button" xd-qa-name="Subscribe"
    >Subscribe</button>
)
